const doc = document.documentElement

export function scrollTop() {
    return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
}

export default function scroll(callback, options = {passive: true}) {
    window.addEventListener('scroll', e => {
        callback(scrollTop())
    }, options)
    callback(scrollTop())
}
